// extracted by mini-css-extract-plugin
module.exports = {"fallback_1imkgk":"fallback_1imkgk","title_3zsvEC":"title_3zsvEC"};